// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Trans as T, useTranslation} from 'react-i18next';
import styles from './uninstall_survey.module.less';
import {img_url} from './img_url';
import {Settings_context} from '../settings_ctx';

const Survey_result = ()=>{
    useTranslation();
    return <div className={cn('basic_page-wrapper',
      styles.page_uninstall_survey_result)}>
      <div className={cn('container')}>
        <div className={styles.survey_root_result}>
          <div className={styles.survey_description_result}>
            <h2><T>We are sorry to see you go</T>.</h2>
            <p>
              <T>We use your feedback to understand how we can make our product
              better and more useful</T>. <T>We're committed to improving
              it, and we hope to see you again in the future</T>.</p>
          </div>
          <div className={styles.survey_block_result}>
            <img alt="Hola install"
              className={cn(styles.img_holi_sad_right, 'lazyload')}
              src={img_url(`mascot/holi_sad.svg`)}/>
          </div>
        </div>
      </div>
    </div>;
};

const New_survey_result = ()=>{
    useTranslation();
    const {theme} = useContext(Settings_context);
    return <div className={styles.survey2023}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h4 className={cn(theme.bold, styles.title)}>Sorry to see you go</h4>
          <img src={'https://hola.org/cms/wp-content/'+
            'uploads/2023/08/Group-1-1.png'}
            className={cn(styles.title_image, 'lazyload')} alt="group_1"/>
        </div>
        <div className={styles.result_description}>
          <p>
            <T>We use your feedback to understand how we can make our product
            better and more useful</T>. <T>We're committed to improving
            it, and we hope to see you again in the future</T>.
          </p>
        </div>
      </div>
    </div>;
};

export {Survey_result, New_survey_result};
